import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';

import { useIdCellStyles } from './idCellStyles';

export const IdCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = useIdCellStyles();

  if (rowType !== 'data') {
    return null;
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box sx={sxStyles.text}>{dataItem.id}</Box>
    </TableCell>
  );
};
